export const navigateTo = (href: string) => {
    if (typeof window !== 'undefined' && window.location) {
        window.location.href = href;
    }
};
